import { useId } from 'react';

import { Campo, CampoSelecao } from './Campo';
import { opcoesDeCompetencia } from './competencias';

/**
 * O campo de DATA da tela (p.61: `02/10/2026`): o seletor de data do próprio
 * navegador, que na página em pt-BR mostra e aceita dd/mm/aaaa e entrega
 * aaaa-mm-dd. O aaaa-mm-dd é só do transporte — a pessoa nunca o digita.
 *
 * Achado dos robôs no QAS (20/10/2026): "Precisa até" era caixa de texto com a
 * ajuda "No formato aaaa-mm-dd", e quem escreveu 30/10/2026, como se escreve no
 * Brasil, levou a recusa do servidor com a orientação de outro campo.
 *
 * `valor` e `aoMudar` falam aaaa-mm-dd (ou vazio).
 */
export function CampoDeData({
  rotulo,
  valor,
  aoMudar,
  opcional = false,
  ajuda,
  min,
  max,
  erro,
}: {
  readonly rotulo: string;
  readonly valor: string;
  readonly aoMudar: (valor: string) => void;
  readonly opcional?: boolean;
  readonly ajuda?: string;
  /** Diz o que fazer; aparece no lugar da ajuda. */
  readonly erro?: string | null;
  /** aaaa-mm-dd */
  readonly min?: string;
  /** aaaa-mm-dd */
  readonly max?: string;
}) {
  const id = useId();
  return (
    <Campo id={id} rotulo={rotulo} opcional={opcional} erro={erro ?? null} {...(ajuda ? { ajuda } : {})}>
      <input
        id={id}
        type="date"
        {...(erro ? { 'aria-invalid': true, 'aria-describedby': `${id}-erro` } : {})}
        className="controle w-full"
        value={valor}
        {...(min ? { min } : {})}
        {...(max ? { max } : {})}
        onChange={(evento) => {
          aoMudar(evento.target.value);
        }}
      />
    </Campo>
  );
}

/**
 * A COMPETÊNCIA (um mês) escolhida por mês e ano escritos — "Setembro de
 * 2026" —, e não digitada como aaaa-mm-01. Lista, e não `type="month"`: o
 * Firefox não tem seletor de mês e mostraria uma caixa de texto de novo.
 *
 * `valor` e `aoMudar` falam aaaa-mm-01, o que o servidor guarda.
 */
export function CampoDeCompetencia({
  rotulo,
  valor,
  aoMudar,
  ajuda,
  hoje = new Date(),
  mesesAFrente,
  mesesAtras,
}: {
  readonly rotulo: string;
  readonly valor: string;
  readonly aoMudar: (valor: string) => void;
  readonly ajuda?: string;
  readonly hoje?: Date;
  /** Quantos meses depois do atual a lista oferece (padrão 1). */
  readonly mesesAFrente?: number;
  /** Quantos meses antes do atual a lista oferece (padrão 24). */
  readonly mesesAtras?: number;
}) {
  /* Só para a frente (mês pretendido), a lista sobe: o mês que vem no topo. */
  const janela = { ...(mesesAFrente !== undefined ? { aFrente: mesesAFrente } : {}), ...(mesesAtras !== undefined ? { atras: mesesAtras } : {}), crescente: mesesAtras === 0 };
  return (
    <CampoSelecao rotulo={rotulo} valor={valor} aoMudar={aoMudar} opcoes={opcoesDeCompetencia(hoje, valor, janela)} {...(ajuda ? { ajuda } : {})} />
  );
}
